import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/lib/Form';
import Col from 'react-bootstrap/lib/Col';
import { Opinion } from './Opinion';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import plLocale from 'date-fns/locale/pl';

export class Comment extends Component {
	render() {
		const { showOpinion = false } = this.props;
		return (
			<div className="act__comment">
				<strong>{this.props.createdBy}</strong>
				<div className="act__comment-ip">{this.props.addressIP}</div>
				<div className="act__comment-date">
					{distanceInWordsToNow(this.props.createdDate, { locale: plLocale })}
				</div>
				<div className="act__comment-content margin-bottom-5">{this.props.content}</div>
				{showOpinion && (
					<Opinion
						commentObjectId={this.props.id}
						comments
						likeCount={this.props.commentLikeCount}
						unlikeCount={this.props.commentUnlikeCount}
						userLikeCount={this.props.userCommentLikeCount}
						userUnlikeCount={this.props.userCommentUnlikeCount}
						userOpinionId={this.props.userCommentOpinionId}
						addOpinion={(id, type) => this.props.addCommentOpinion(id, type)}
						removeOpinion={(id) => this.props.removeCommentOpinion(id)}
						opinionExecuting={this.props.opinionExecuting}
						disabled={!this.props.canCommentAndSetOpinion}
						agreementAccepted={this.props.agreementAccepted}
						agreementAcceptedRequired={this.props.agreementAcceptedRequired}
						scrollToAgreement={this.props.scrollToAgreement}
					/>
				)}
			</div>
		);
	}
}

Comment.propTypes = {
	addressIP: PropTypes.string,
	canCommentAndSetOpinion: PropTypes.bool,
	commentLikeCount: PropTypes.number,
	commentUnlikeCount: PropTypes.number,
	content: PropTypes.string,
	createdBy: PropTypes.string,
	createdDate: PropTypes.string,
	prefixName: PropTypes.string,
	userCommentLikeCount: PropTypes.number,
	userCommentUnlikeCount: PropTypes.number,
	userCommentOpinionId: PropTypes.number,

	addCommentOpinion: PropTypes.func,
	removeCommentOpinion: PropTypes.func
};

Comment.defaultProps = {
	addressIP: '',
	canCommentAndSetOpinion: false,
	commentLikeCount: 0,
	commentUnlikeCount: 0,
	content: '',
	createdBy: '',
	createdDate: '',
	prefixName: '',
	userCommentLikeCount: 0,
	userCommentUnlikeCount: 0,
	userCommentOpinionId: 0,
	opinionExecuting: [],
	agreementAccepted: false,
	agreementAcceptedRequired: false,
	scrollToAgreement: Function.prototype,

	addCommentOpinion: Function.prototype,
	removeCommentOpinion: Function.prototype
};
